module.exports = __webpack_public_path__ + "static/media/sp16.7695e37c.JPG";